export const NON_UPDATED_PASSWORD = 'non-updated-password'
export const OAUTH2_AUTHORIZATION_RESOURCE = 'OAUTH2_AUTHORIZATION_RESOURCE';
export const IDENTITY_PROVIDER_ROLE = 'IDENTITY_PROVIDER_ROLE';
export const DATA_PROVIDER_ROLE = 'DATA_PROVIDER_ROLE';
